import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    REJECT_SET_SUCCESS,
    REJECT_SET_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* rejectSet(action) {
    const requestPayload = action?.payload || {};
    const baseSiteId = localStorage.getItem('baseSiteId');
    const params = convertObjectToQueryParams(requestPayload);
    const url = `/occ/v2/${baseSiteId}/dashboard/set/reject?${params}`;

    try {
        const result = yield axios.post(url).then((response) => response.data);

        yield put({ type: REJECT_SET_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload,
        });
        yield put({
            type: REJECT_SET_FAILURE,
            payload: errorHandler(error?.response?.status || '503'),
        });
    }
}
